import { useNavigate } from 'react-router-dom';

import privacyPolicyMarkdown from '../../legal-documents/privacy-policy.md?raw';
import LegalDocumentPage from './legal-document-page';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate('/dashboard', { replace: true });
    }
  };

  return <LegalDocumentPage markdown={privacyPolicyMarkdown} onBack={handleBack} />;
};

export default PrivacyPolicy;
